<template lang="pug">
  .content-wrapper(style='min-height: 591px;')
    h1 RFI - Solicitudes de Información
    notificacion(ref="notificacion")
    .card.card-principal
      .card-body
        .content
          .row
            .col-lg-12
              router-view
</template>

<script>

import Notificacion from "./notificacion";

export default {
  name: "Content",
  components: {
    Notificacion
  },
  mounted() {
    // Botetín de notificaciones
    this.$root.$on('showNotificationSuccess', ($event) => {
      this.$refs.notificacion.notificar($event.mensaje, 'success');
    });

    this.$root.$on('showNotificationError', ($event) => {
      this.$refs.notificacion.notificar($event.mensaje, 'error');
    });

    this.$root.$on('showNotificationWarning', ($event) => {
      this.$refs.notificacion.notificar($event.mensaje, 'warning');
    });
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
